import React from 'react';
import { useSearchkit } from '@searchkit/client';
import { useTranslation } from 'react-i18next';

import {
  Button,
  FormikWrapper,
  FormSelect,
  FormTextField,
  Icon,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const PROVINCE_OPTIONS = {
  drenthe: 'Drenthe',
  flevoland: 'Flevoland',
  friesland: 'Friesland',
  gelderland: 'Gelderland',
  groningen: 'Groningen',
  limburg: 'Limburg',
  brabant: 'Noord-Brabant',
  noord_holland: 'Noord-Holland',
  overijssel: 'Overijssel',
  utrecht: 'Utrecht',
  zeeland: 'Zeeland',
  zuid_holland: 'Zuid-Holland',
};

const VolunteerWorkSearchBar = () => {
  const api = useSearchkit();
  const { t } = useTranslation();

  const initialValues = {
    title: '',
    province: null,
  };

  const filterProvince = (value) => {
    api.removeFiltersByIdentifier('provinces');

    if (value) {
      api.addFilter({
        identifier: 'provinces',
        value: value,
      });
    }

    api.search();
  };

  const onSubmit = (values) => {
    api.setQuery(values.title);

    if (values.province) {
      filterProvince(values.province);
    }

    api.search();
  };

  const resetOnEmpty = (value) => {
    if (value.target.value === '') {
      api.setQuery('');
      api.search();
    }
  };

  return (
    <div className="VolunteerWorkSearchBar">
      <p className="VolunteerWorkSearchBar__label">{t('search_label')}</p>
      <FormikWrapper
        initialValues={initialValues}
        onSubmit={onSubmit}
      >
        <FormTextField
          fieldName="title"
          placeholder={t('search_nldoet.placeholder')}
          onChange={resetOnEmpty}
        >
          <Icon name="search" />
        </FormTextField>
        <FormSelect
          fieldName="province"
          placeholder={t('search_nldoet.province')}
          options={PROVINCE_OPTIONS}
          onChange={filterProvince}
        />
        <Button type="submit">
          {t('search_button')}
          <Icon name="arrow_forward" flair="outlined" />
        </Button>
      </FormikWrapper>
    </div>
  );
};

export default VolunteerWorkSearchBar;
